module.exports = 'PatronTechnologyCheckoutWrapper';
